import { Injectable, inject } from '@angular/core';
import { HubConnection } from '@microsoft/signalr';
import { NotificationService } from '@simac/ui';
import { Subject, take } from 'rxjs';
import { INotificationArgs } from '../models/signalling';
import { BaseSignalingService } from './base-signalling.service';

@Injectable({
  providedIn: 'root',
})
export class NotificcationSignalingService extends BaseSignalingService {
  private readonly notificationService = inject(NotificationService);

  private readonly hubStartedConnection = new Subject<HubConnection>();

  constructor() {
    super();
    this.hubStartedConnection.pipe(take(1)).subscribe((hubConnection: HubConnection) => {
      this.subscribeSignallingEvents(hubConnection);
    });
  }

  connectToNotificationHub(): void {
    this.connectToHub('/hubs/notification', this.hubStartedConnection);
  }

  stopNotificationHubConnection(): void {
    this.stopHubConnection('/hubs/notification');
  }

  private subscribeSignallingEvents(hubConnection: HubConnection): void {
    hubConnection.on('NotificationReceived', (model: INotificationArgs) => {
      this.notificationService.notificationReceived.next(model.unseenCount);
    });
    hubConnection.on('NotificationsSeen', (model: INotificationArgs) => {
      this.notificationService.notficiationsSeen.next(model.unseenCount);
    });
  }
}
